export default "__VITE_ASSET__QwJD6EN6__"